(function () {
    'use strict';

    var gettext = angular.identity;

    angular.module('app.password-reset')
        .constant('passwordResetResources', {
            passwordResetSucceeded: gettext('Your password has been reset.'),
            passwordResetFailed: gettext('Failed to reset password.'),

            passwordResetEmailSucceeded: gettext('If an account was found with that address an email will be sent.'),
            passwordResetEmailFailed: gettext('Server failed to send you a password reset email.'),
        });
})();
